import { render, staticRenderFns } from "./USBoardTable.vue?vue&type=template&id=66a745ae&scoped=true"
import script from "./USBoardTable.vue?vue&type=script&lang=js"
export * from "./USBoardTable.vue?vue&type=script&lang=js"
import style0 from "./USBoardTable.vue?vue&type=style&index=0&id=66a745ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a745ae",
  null
  
)

export default component.exports